var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "address-input" },
    [
      _vm._t("header-text"),
      _vm._v(" "),
      _c("p", {
        staticClass: "address-input__name",
        domProps: { textContent: _vm._s(_vm.name) },
      }),
      _vm._v(" "),
      _c("AddressAutocomplete", { on: { placeChanged: _vm.onPlaceChanged } }),
      _vm._v(" "),
      _c("SmoothReflow", { attrs: { show: _vm.meta.manualMode } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.unit_number,
                    label: "Unit Number",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.unit_number },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("unit_number", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.street_number,
                    label: "Street Number",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.street_number },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("street_number", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.street_name,
                    label: "Street Name",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.street_name },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("street_name", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.suburb,
                    label: "Suburb",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.suburb },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("suburb", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.state,
                    label: "State",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.state },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("state", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    "error-container": _vm.errorContainer,
                    name: _vm.errorPrefixedKeys.postcode,
                    label: "Postcode",
                    floating: true,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: " " },
                    domProps: { value: _vm.proxyValue.postcode },
                    on: {
                      input: function ($event) {
                        return _vm.setPlaceField("postcode", $event)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c("CountrySelect", {
                attrs: {
                  value: _vm.proxyValue.country,
                  "value-by": "name",
                  "error-container": _vm.errorContainer,
                  name: _vm.errorPrefixedKeys.country,
                  label: "Country",
                  floating: true,
                },
                on: {
                  input: function ($event) {
                    return _vm.setRawField("country", $event)
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.duration
        ? [
            _c("p", { staticClass: "address-input__duration-label" }, [
              _vm._v("How long have you lived at this address?"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "FormGroup",
                    {
                      attrs: {
                        "error-container": _vm.errorContainer,
                        name: _vm.errorPrefixedKeys.years,
                        label: "Number of years",
                        floating: true,
                      },
                    },
                    [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          min: "0",
                          name: "number_of_years",
                          step: "1",
                          type: "number",
                          placeholder: " ",
                        },
                        domProps: { value: _vm.proxyValue.years },
                        on: {
                          input: function ($event) {
                            return _vm.setPlaceField("years", $event)
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "FormGroup",
                    {
                      attrs: {
                        "error-container": _vm.errorContainer,
                        name: _vm.errorPrefixedKeys.months,
                        label: "Number of months",
                        floating: true,
                      },
                    },
                    [
                      _c("FmSelect", {
                        attrs: {
                          value: _vm.proxyValue.months,
                          options: _vm.monthOptions,
                          icons: _vm.monthIcons,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setRawField("months", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("extra-text"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }